import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {actions, select} from './connectors';
import {UUID} from '~/constants/RegexConstants';
import {iconPropType} from '~/data/records/icons';
import {isArt, isNamesOrNumbers, isText, isUpload} from '~/data/accessors/icon';
import {
  artIcon,
  itemsIcon,
  namesIcon,
  textIcon,
  uploadIcon
} from '~/constants/InlineSvgs';
// components
import Menu from '~/shared/components/Menu/index';
import MenuButton from '~/shared/components/MenuButton/index';
import UploadButton from '~/components/UploadButton';
import withRouter, {routerPropTypes} from '~/router/withRouter';

import './index.scss';
import FullPageDropzone from '~/components/UploadDropzone/FullPageDropzone';

const propTypes = {
  allowsNamesAndNumbers: PropTypes.bool,
  analytics: PropTypes.shape({
    textStart: PropTypes.func
  }),
  currentProduct: PropTypes.object,
  isFundraisingMode: PropTypes.bool,
  router: routerPropTypes,
  selectedIcons: PropTypes.arrayOf(iconPropType),
  welcoming: PropTypes.bool
};

/** @extends {Component<PropTypes.InferProps<typeof propTypes>>} */
export class MainMenuBar extends Component {
  static propTypes = propTypes;

  static defaultProps = {
    allowsNamesAndNumbers: true,
    selectedIcons: [],
    isFundraisingMode: false,
    welcoming: false
  };

  state = {
    welcome: !!this.props.welcoming
  };

  dismissOverlay = () => {
    this.setState({
      welcome: false
    });
  };

  dismissADOverlay = () => {
    this.setState({
      showAD: false
    });
  };

  render() {
    const {
      isFundraisingMode,
      selectedIcons,
      router,
      allowsNamesAndNumbers,
      isAddToClipartEnabled
    } = this.props;

    const {type, id} = selectedIcons[0] || {};
    const singleIconSelected = selectedIcons.length === 1;

    if (id && !UUID.test(id)) {
      return null;
    }

    const singleTextIconSelected = isText(type) && singleIconSelected;
    const textLabel = `${singleTextIconSelected ? 'edit' : 'add'} text`;

    const singleArtIconSelected = isArt(type) && singleIconSelected;
    const clipartLabel = isAddToClipartEnabled ? 'clipart' : 'art';
    const artLabel = `${singleArtIconSelected ? 'edit' : 'add'} ${clipartLabel}`;

    const singleUploadIconSelected = isUpload(type) && singleIconSelected;
    const uploadLabel = singleUploadIconSelected ? 'edit' : 'upload';

    const singleNamesIconSelected =
      isNamesOrNumbers(type) && singleIconSelected;
    const namesLabel = `${singleNamesIconSelected ? 'edit' : ''} names`;

    const textRoute = singleTextIconSelected ? '/textTools' : '/addText';

    const artRoute = singleArtIconSelected ? '/artTools' : '/addArt?rs=m';

    const namesRoute = singleNamesIconSelected
      ? '/namesAndNumbers/tools'
      : '/namesAndNumbers';

    const uploadButton = (
      <MenuButton
        className="ndx-MainMenuBar-item"
        icon={uploadIcon}
        text={uploadLabel}
        onClick={
          isUpload(type) && singleIconSelected
            ? () => router.navigate('/uploadTools')
            : null
        }
      />
    );

    const uploadButtonHolder = isUpload(type) ? (
      uploadButton
    ) : (
      <UploadButton>{uploadButton}</UploadButton>
    );

    return (
      <div className="ndx-MainMenuContainer">
        <Menu className="ndx-MainMenuBar">
          <MenuButton
            className="ndx-MainMenuBar-item"
            icon={itemsIcon}
            text="product"
            onClick={() => router.navigate('/productDetails')}
          />

          <FullPageDropzone />
          {uploadButtonHolder}

          <MenuButton
            className="ndx-MainMenuBar-item"
            icon={textIcon}
            text={textLabel}
            onClick={() => {
              if (textRoute === '/addText') {
                this.props.analytics.textStart({
                  source: 'menu'
                });
              }
              router.navigate(textRoute);
            }}
          />

          <MenuButton
            className="ndx-MainMenuBar-item"
            icon={artIcon}
            text={artLabel}
            onClick={() => router.navigate(artRoute)}
          />

          {!isFundraisingMode && allowsNamesAndNumbers && (
            <MenuButton
              className="ndx-MainMenuBar-item"
              icon={namesIcon}
              text={namesLabel}
              onClick={() => router.navigate(namesRoute)}
            />
          )}
        </Menu>
      </div>
    );
  }
}

export default connect(select, actions)(withRouter(MainMenuBar));
